<template>
    <v-container>
        <h1 class="titulo mb-3 primary-color">Configuração de Bancos</h1>
        <v-card class="card">
            <v-card-text>
                <m-form ref="form">
                    <v-row class="ml-1">
                        <v-switch v-model="model.tipo_banco"
                                  :label="`Tipo de Banco: ${model.tipo_banco ? tipos_configuracao.debito_automatico.label : tipos_configuracao.devolucao.label}`"></v-switch>
                    </v-row>
                    <v-row>
                        <v-col cols="6" md="4">
                            <DynamicSelect label="Empresa:" id="SelectEmpresa" v-model="configuracao.empresas"
                                           :items="dadosConfiguracao.empresas" :disabled="configuracao.marcarTodas"
                                           :filled="configuracao.marcarTodas" endpoint="/dynamic-selects/empresas/id"
                                           placeholder="Selecione a(s) empresa(s)"
                                           :multiple="true" />
                        </v-col>
                        <v-col cols="6" md="3">
                            <DynamicSelect label="Marca:" id="SelectMarca" v-model="configuracao.marcas"
                                           :items="dadosConfiguracao.marcas" :disabled="configuracao.marcarTodas"
                                           :filled="configuracao.marcarTodas" endpoint="/dynamic-selects/flavors/id"
                                           placeholder="Selecione a(s) marca(s)"
                                           :multiple="true" />
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-autocomplete label="Unidade de Negócio:" id="SelectUnNegocio"
                                            v-model="configuracao.unidades_negocio" :items="dadosConfiguracao.unidades_negocio"
                                            :disabled="configuracao.marcarTodas" :filled="configuracao.marcarTodas"
                                            item-text="label" item-value="value" outlined clearable
                                            :search-input.sync="searchUnidade"
                                            placeholder="Selecione a(s) unidade(s)"
                                            :multiple="true" />
                        </v-col>
                        <v-col cols="6" md="2" class="d-flex align-center">
                            <v-checkbox class="mt-4" v-model="configuracao.marcarTodas" label="Todas"
                                        @change="handleChangeTodas" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" md="4">
                            <v-autocomplete label="Bancos Exibidos:" id="SelectBancosExibidos"
                                            v-model="configuracao.bancos_exibir" :items="bancosComTodos" :multiple="true"
                                            item-text="label" item-value="value" item-disabled="disabled" outlined clearable
                                            :search-input.sync="searchBancoExibir"
                                            placeholder="Selecione o(s) banco(s)" />
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-autocomplete label="Bancos Ocultados:" id="SelectBancosOcultados"
                                            v-model="configuracao.bancos_ocultar" :items="bancosOcultosComTodos" :multiple="true"
                                            item-text="label" item-value="value" outlined clearable
                                            :search-input.sync="searchBancoOcultar"
                                            placeholder="Selecione o(s) banco(s)" />
                        </v-col>
                    </v-row>
                    <v-row class="d-flex justify-space-between mb-4">
                        <v-col cols="8">
                            <HintMessage style="max-width: 500;" class="mt-8 mb-5" title="DICA PARA CONFIGURAÇÃO"
                                         icon="mdi-lightbulb-on-outline" icon-color="secondary"
                                         description="<p>A opção “Todas” marca <strong>todas as entidades</strong> de “Empresa/Marca/Unidade de Negócio”.</p> <p>Mesmo contendo a liberação <strong>dos bancos para todas as entidades, você pode configurar um ou mais bancos para entidades específicas.</strong></p>"
                                         :description-html="true"
                                         :center-icon="false"
                            />
                        </v-col>
                        <v-col cols="4" class="d-flex justify-end mt-4">
                            <v-btn class="transition" color="secondary" type="reset" rounded @click="resetForm">
                                Limpar
                            </v-btn>
                            <v-btn class="transition ml-2" color="primary" rounded @click="inserir">
                                Salvar
                            </v-btn>
                        </v-col>
                    </v-row>
                </m-form>
                <v-layout>
                    <v-btn class="transition ml-1" color="primary" rounded @click="toggleFiltro">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar Por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" v-show="filter_open" class="mt-4 ml-2">
                        <v-row>
                            <v-col cols="6">
                                <v-select label="Tipo de Banco:" id="SelectFilterTipoBanco"
                                          v-model="filters.tipo_banco" :items="tipoBancoOptions"
                                          item-text="label" item-value="value" outlined clearable
                                          placeholder="Selecione o tipo de banco" />
                            </v-col>
                            <v-col cols="6">
                                <DynamicSelect label="Empresa:" id="SelectFilterEmprea"
                                               v-model="filters.empresas" :items="dadosConfiguracao.empresas"
                                               endpoint="/dynamic-selects/empresas/id"
                                               placeholder="Selecione a(s) empresa(s)" :multiple="true"
                                />
                            </v-col>
                            <v-col cols="6">
                                <DynamicSelect label="Marca:" id="SelectFilterMarca"
                                               v-model="filters.marcas" :items="dadosConfiguracao.marcas"
                                               endpoint="/dynamic-selects/flavors/id"
                                               placeholder="Selecione a(s) marca(s)" :multiple="true"
                                />
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete label="Unidade de Negócio:" id="SelectFilterUnNegocio"
                                                v-model="filters.unidades_negocio" :items="dadosConfiguracao.unidades_negocio"
                                                item-text="label" item-value="value" outlined clearable
                                                :search-input.sync="searchUnidade"
                                                placeholder="Selecione a(s) unidade(s)"
                                                :multiple="true" />
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete label="Bancos Exibidos:" id="SelectBancosFilterExibidos"
                                                v-model="filters.bancos_exibir" :items="dadosConfiguracao.bancos_exibir" :multiple="true"
                                                item-text="label" item-value="value" item-disabled="disabled" outlined clearable
                                                :search-input.sync="searchBancoExibir"
                                                placeholder="Selecione o(s) banco(s)" />
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete label="Bancos Ocultos:" id="SelectBancosFilterOcultos"
                                                v-model="filters.bancos_ocultar" :items="dadosConfiguracao.bancos_ocultar" :multiple="true"
                                                item-text="label" item-value="value" item-disabled="disabled" outlined clearable
                                                :search-input.sync="searchBancoOcultar"
                                                placeholder="Selecione o(s) banco(s)" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="d-flex justify-start">
                                <v-btn color="secondary" @click="limpar">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="d-flex justify-end">
                                <v-btn color="primary" @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <DataTable ref="datatable" url="/painel/config_bancos/listar" class="listagem pt-2 data-table-overlow"
                           :headers="headers" :params="params" :filter="dtFiltro" id="data-table">
                    <template v-slot:items="{item}">
                        <td class="text-center">
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">
                                            O que deseja fazer?
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <v-list-item-title>Editar</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirmExcluir(item.id)">
                                        <v-list-item-title>Excluir</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td class="text-center">
                            <div class="d-flex" style="max-width: 100%; flex-wrap: wrap !important; justify-content: center;">
                                <template v-if="item.todas_entidades == 0">
                                    <div v-for="(empresa, index) in getEmpresa(item)" :key="index"
                                         class="text-center ma-1 span">
                                        {{ empresa }}
                                    </div>
                                </template>
                                <template v-else-if="item.todas_entidades == 1">
                                    <div class="text-center ma-1 span">Todas</div>
                                </template>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="d-flex" style="max-width: 100%; flex-wrap: wrap; justify-content: center;">
                                <template v-if="item.todas_entidades == 0">
                                    <div v-for="(marca, index) in getMarca(item)" :key="index"
                                         class="text-center ma-1 span">
                                        {{ marca }}
                                    </div>
                                </template>
                                <template v-else-if="item.todas_entidades == 1">
                                    <div class="text-center ma-1 span">Todas</div>
                                </template>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="d-flex" style="max-width: 100%; flex-wrap: wrap; justify-content: center;">
                                <template v-if="item.todas_entidades == 1">
                                    <div class="text-center ma-1 span">Todas</div>
                                </template>
                                <template v-else-if="item.todas_entidades == 0 && item.unidades_negocio.length">
                                    <div v-for="(unidade, index) in item.unidades_negocio" :key="index"
                                         class="text-center ma-1 span">
                                        {{ unidade }}
                                    </div>
                                </template>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="d-flex" style="max-width: 100%; flex-wrap: wrap; justify-content: center;">
                                <template v-if="item.todos_bancos == 1">
                                    <div class="text-center ma-1 span">Todos</div>
                                </template>
                                <template v-else-if="item.todos_bancos == 0 && item.bancos_exibidos_nomes.length">
                                    <div v-for="(banco, index) in item.bancos_exibidos_nomes" :key="index"
                                         class="text-center ma-1 span">
                                        {{ banco }}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="text-center ma-1">-</div>
                                </template>
                            </div>
                        </td>
                        <td class="text-center">
                            <div class="d-flex" style="max-width: 100%; flex-wrap: wrap; justify-content: center;">
                                <template v-if="item.todos_bancos_ocultos == 1">
                                    <div class="text-center ma-1 span">Todos</div>
                                </template>
                                <template v-else-if="item.todos_bancos_ocultos == 0 && item.bancos_ocultos_nomes.length">
                                    <div v-for="(banco, index) in item.bancos_ocultos_nomes" :key="index"
                                         class="text-center ma-1 span">
                                        {{ banco }}
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="text-center ma-1">-</div>
                                </template>
                            </div>
                        </td>
                        <td class="text-center ma-1 span">
                            {{ item.tipo_banco == 1 ? 'Débito' : 'Devolução' }}
                        </td>
                    </template>
                </DataTable>
                <v-row>
                    <v-col style="margin-bottom: 14px;">
                        <v-btn color="primary" @click="exportarExcel">
                            <v-icon left size="18">
                                mdi-file-document-outline
                            </v-icon>
                            Gerar Relatório
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '@/plugins/alerts_types'
  import { alert } from '../../../plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'ConfiguracoesBancos',
    data: () => ({
      filter_open: false,
      pagination: {
        sortBy: [], descending: []
      },
      model: {
        tipo_banco: false
      },
      searchBancoOcultar: '',
      searchBancoExibir: '',
      searchUnidade: '',
      dtFiltro: {},
      configuracao: {
        empresas: [],
        marcas: [],
        unidades_negocio: [],
        bancos_exibir: [],
        bancos_ocultar: [],
        todos_bancos: false,
        todos_bancos_ocultos: false,
        marcarTodas: false
      },
      dadosConfiguracao: {
        empresas: [],
        marcas: [],
        unidades_negocio: [],
        bancos_exibir: [],
        bancos_ocultar: []
      },
      headers: [
        { text: 'Ações', value: '', align: 'center', sortable: false },
        { text: 'Empresa', value: 'empresas', align: 'center', sortable: true },
        { text: 'Marca', value: 'marcas', align: 'center', sortable: true },
        { text: 'Unidade de Negócio ', value: 'unidades_negocio', align: 'center', sortable: true },
        { text: 'Bancos Exibidos', value: 'bancos_exibidos', align: 'center', sortable: true },
        { text: 'Bancos Ocultos', value: 'bancos_ocultos', align: 'center', sortable: true },
        { text: 'Tipo de Banco', value: 'tipo_banco', align: 'center', sortable: true }
      ],
      filters: {
        tipo_banco: null,
        empresas: [],
        marcas: [],
        unidades_negocio: [],
        bancos_exibir: [],
        bancos_ocultar: []
      }
    }),
    computed: {
      params () {
        return { pagination: this.pagination }
      },
      unidades () {
        return this.$session.get('unidades').map(unidade => ({ value: unidade.id_unidade_negocio, label: `${unidade.cd_unidade_negocio} - ${unidade.nm_unidade_negocio}` }))
      },
      tipos_configuracao () {
        return {
          debito_automatico: { label: 'Débito Automático', value: 1 },
          devolucao: { label: 'Devolução', value: 0 },
          marcarTodas: { label: 'Todos', value: '' }
        }
      },
      tipoBancoOptions () {
        return [
          { label: this.tipos_configuracao.debito_automatico.label, value: this.tipos_configuracao.debito_automatico.value },
          { label: this.tipos_configuracao.devolucao.label, value: this.tipos_configuracao.devolucao.value }
        ]
      },
      bancosComTodos () {
        const selecionouTodosOcultos = this.configuracao.bancos_ocultar.includes('todos')
        return [
          { value: 'todos', label: 'Todos', disabled: selecionouTodosOcultos },
          ...this.dadosConfiguracao.bancos_exibir.filter(banco =>
            !this.configuracao.bancos_ocultar.includes(banco.value)
          )
        ]
      },
      bancosOcultosComTodos () {
        const selecionouTodosExibir = this.configuracao.bancos_exibir.includes('todos')
        return [
          { value: 'todos', label: 'Todos', disabled: selecionouTodosExibir },
          ...this.dadosConfiguracao.bancos_ocultar.filter(banco =>
            !this.configuracao.bancos_exibir.includes(banco.value)
          )
        ]
      }
    },
    watch: {
      'configuracao.bancos_exibir' (novosValores) {
        if (novosValores.includes('todos') && novosValores.length > 1) {
          this.configuracao.bancos_exibir = ['todos']
        }
        this.configuracao.todos_bancos = novosValores.includes('todos')
        this.searchBancoExibir = ''
      },
      'configuracao.bancos_ocultar' (novosValores) {
        if (novosValores.includes('todos') && novosValores.length > 1) {
          this.configuracao.bancos_ocultar = ['todos']
        }
        this.configuracao.todos_bancos_ocultos = novosValores.includes('todos')
        this.searchBancoOcultar = ''
      },
      'configuracao.unidades_negocio' () {
        this.searchUnidade = ''
      },
      'filters.unidades_negocio' () {
        this.searchUnidade = ''
      },
      'filters.bancos_exibir' () {
        this.searchBancoExibir = ''
      },
      'filters.bancos_ocultar' () {
        this.searchBancoOcultar = ''
      }
    },
    async mounted () {
      await this.getInputsData()
    },
    methods: {
      async getInputsData () {
        const getBancos = this.getBancos()
        this.dadosConfiguracao.unidades_negocio = this.unidades
        return Promise.all([getBancos])
      },
      getUnidade (unidade) {
        if (unidade) {
          return unidade.cd_unidade_negocio + ' - ' + unidade.nm_unidade_negocio
        } else {
          return '-'
        }
      },
      getMarca (item) {
        if (item.marcas && item.marcas.length > 0) {
          return item.marcas
        } else {
          return ['-']
        }
      },
      getEmpresa (item) {
        if (item.empresas && item.empresas.length > 0) {
          return item.empresas
        } else {
          return '-'
        }
      },
      async getBancos () {
        try {
          const response = await this.$http.get('/bancos')
          const bancosData = response.data.map(banco => ({
            value: banco.id_banco,
            label: banco.nome
          }))

          this.dadosConfiguracao.bancos_exibir = bancosData
          this.dadosConfiguracao.bancos_ocultar = bancosData
        } catch (error) {
          notification('error', 'Prezado parceiro, ocorreu um erro ao carregar os bancos, sugerimos recarregar a página e caso o erro persista entre em contato com a Área de Suporte.')
        }
      },
      async salvaConfiguracaoBancos (payload, id = null) {
        if (id) {
          return this.$http.put(`/painel/config_bancos/editar/${id}`, payload)
        }
        return this.$http.post('/painel/config_bancos/inserir', payload)
      },

      async confirmExcluir (id) {
        alert({
          text: `Tem certeza que deseja excluir essa configuração de banco?`,
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              try {
                await this.$http.delete(`/painel/config_bancos/excluir/${id}`)
                notification(AlertTypes.SUCCESS, 'Configuração de banco excluída com sucesso!')
                this.$refs.datatable.reload()
              } catch (error) {
                notification(AlertTypes.ERROR, `Não foi possível excluir a configuração no momento. Erro: ${error.response?.data?.error || error.message}`)
              }
            }
          }
        })
      },
      exportarExcel () {
        const filtros = {
          tipo_banco: this.filters.tipo_banco,
          id_empresa: this.filters.empresas,
          id_marca: this.filters.marcas,
          id_unidade_negocio: this.filters.unidades_negocio,
          bancos_exibidos: this.filters.bancos_exibir,
          bancos_ocultos: this.filters.bancos_ocultar
        }

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/config_bancos/exportar?${encoded_params}`)
      },
      async editar (item) {
        this.model.tipo_banco = item.tipo_banco === 1
        this.configuracao = {
          id: item.id,
          empresas: item.todas_entidades ? [] : (item.id_empresa ? item.id_empresa.split(',').map(id => parseInt(id)) : []),
          marcas: item.todas_entidades ? [] : (item.id_marca ? item.id_marca.split(',').map(id => parseInt(id)) : []),
          unidades_negocio: item.todas_entidades ? [] : (item.id_unidade_negocio ? item.id_unidade_negocio.split(',').map(id => parseInt(id)) : []),
          bancos_exibir: item.todos_bancos ? ['todos'] : (item.bancos_exibidos ? item.bancos_exibidos.split(',').map(id => parseInt(id)) : []),
          bancos_ocultar: item.todos_bancos_ocultos ? ['todos'] : (item.bancos_ocultos ? item.bancos_ocultos.split(',').map(id => parseInt(id)) : []),
          todos_bancos: item.todos_bancos === 1,
          todos_bancos_ocultos: item.todos_bancos_ocultos === 1,
          marcarTodas: item.todas_entidades === 1
        }

        try {
          if (!this.dadosConfiguracao.unidades_negocio.length) {
            this.dadosConfiguracao.unidades_negocio = this.unidades
          }

          if (!this.configuracao.marcarTodas) {
            if (item.id_empresa) {
              const empresasIds = item.id_empresa.split(',').map(id => parseInt(id))
              this.dadosConfiguracao.empresas = empresasIds.map(id => ({ id }))
            }

            if (item.id_marca) {
              const marcasIds = item.id_marca.split(',').map(id => parseInt(id))
              this.dadosConfiguracao.marca = marcasIds.map(id => ({ id }))
            }
          }
          this.$refs.form.resetValidation()
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar os dados para edição.')
        }
        this.$refs.form.resetValidation()
      },
      async inserir () {
        if (!this.verificaCondicoesSelecionadas()) {
          notification(AlertTypes.WARN, 'É necessário selecionar ao menos um campo para prosseguir.')
          return
        }

        try {
          const payload = {
            tipo_banco: this.model.tipo_banco ? 1 : 0,
            id_empresa: this.configuracao.marcarTodas ? [] : this.configuracao.empresas,
            id_marca: this.configuracao.marcarTodas ? [] : this.configuracao.marcas,
            id_unidade_negocio: this.configuracao.marcarTodas ? [] : this.configuracao.unidades_negocio,
            bancos_exibidos: this.configuracao.bancos_exibir.includes('todos') ? [] : this.configuracao.bancos_exibir,
            bancos_ocultos: this.configuracao.bancos_ocultar.includes('todos') ? [] : this.configuracao.bancos_ocultar,
            todos_bancos: this.configuracao.todos_bancos ? 1 : 0,
            todos_bancos_ocultos: this.configuracao.todos_bancos_ocultos ? 1 : 0,
            todas_entidades: this.configuracao.marcarTodas ? 1 : 0
          }

          if (this.configuracao.id) {
            await this.salvaConfiguracaoBancos(payload, this.configuracao.id)
            notification(AlertTypes.SUCCESS, 'Configurações de bancos atualizadas com sucesso!')
          } else {
            await this.salvaConfiguracaoBancos(payload)
            notification(AlertTypes.SUCCESS, 'Configurações de bancos salvas com sucesso!')
          }
          this.resetForm()
          this.$refs.datatable.reload()
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      handleChangeTodas () {
        this.limparTodosOsCampos()
      },
      limparTodosOsCampos () {
        this.configuracao.empresas = []
        this.configuracao.marcas = []
        this.configuracao.unidades_negocio = []
      },
      resetForm () {
        this.configuracao = {
          id: null,
          empresas: [],
          marcas: [],
          unidades_negocio: [],
          bancos_exibir: [],
          bancos_ocultar: [],
          todos_bancos: false,
          marcarTodas: false
        }
        this.model.tipo_banco = false
        this.$refs.form.resetValidation()
      },
      verificaCondicoesSelecionadas () {
        return (
          (this.configuracao.empresas && this.configuracao.empresas.length > 0) ||
          (this.configuracao.marcas && this.configuracao.marcas.length > 0) ||
          (this.configuracao.unidades_negocio && this.configuracao.unidades_negocio.length > 0) ||
          (this.configuracao.marcarTodas === true)
        )
      },
      filtrar () {
        if (this.$refs.filter.validate()) {
          const filtros = {
            tipo_banco: this.filters.tipo_banco,
            id_empresa: this.filters.empresas,
            id_marca: this.filters.marcas,
            id_unidade_negocio: this.filters.unidades_negocio,
            bancos_exibidos: this.filters.bancos_exibir,
            bancos_ocultos: this.filters.bancos_ocultar
          }
          this.dtFiltro = filtros
        }
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      limpar () {
        this.filters = {
          tipo_banco: null,
          empresas: [],
          marcas: [],
          unidades_negocio: [],
          bancos_exibir: [],
          bancos_ocultar: []
        }
        this.filtrar()
        this.filter_open = false
      }

    }
  }
</script>

<style>
    .span {
        text-align: center;
        box-sizing: border-box;
        word-break: break-all;
        width: fit-content;
        font-size: 14px;
        line-height: 1.4;
    }

    .listagem th {
        height: 52px !important;
        white-space: nowrap !important;
    }

    .listagem td,
    .listagem th {
        vertical-align: middle !important;
    }

</style>
